<template>
    <div class="process-container">
        <div v-for="(step, index) in steps" :key="index" class="header-image" :class="{active: index==selectedStepIndex}" :style="`background-image: url(${step.header_image['url']};`">
            <div v-if="step.add_background_overlay" class="overlay" :style="{opacity: step.background_overlay_opacity}"></div>
            <div class="content">
                <div class="top-title">Step {{index+1}}</div>
                <h1 class="title" v-html="step.title"></h1>
            </div>
        </div>
        <div class="steps-container">
            <slick-carousel ref="carousel" :options="getCarouselOptions()" class="steps-carousel" v-on:afterChange="carouselChanged">
                <div v-for="(step, index) in steps" :key="index" class="step" :class="[{active: index==selectedStepIndex}, {previous: index < selectedStepIndex}]" @mouseenter="setSelectedStep(index)">
                    <div class="step-number" v-html="getStepNumber(index)"></div>
                    <div class="content-container">
                        <h2 class="title" v-html="step.title"></h2>
                        <div class="description" v-html="step.description"></div>
                        <div class="button-container" v-if="step.button">
                            <a class="hover-button white" :href="step.button.url" :target="step.button.target" v-html="step.button.title"></a>
                        </div>
                    </div>
                </div>
            </slick-carousel>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        steps: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            selectedStepIndex: 0
        }
    },
    mounted() {
    },
    computed : {
        selectedStep : function() {
            return this.steps[this.selectedStepIndex];
        }
    },
    methods: {
        setSelectedStep(index) {
            this.selectedStepIndex = index;
        },
        getStepNumber(index) {
            var step = index + 1;
            if (step < 10) {
                step = '0'+step;
            }
            return step;
        },
        getCarouselOptions() {
            return {
                'slidesToShow': 4,
                'slidesToScroll': 1,
                'prevArrow': '<i class="slick-arrow top btn-blue prev fas fa-chevron-left"></i>',
                'nextArrow': '<i class="slick-arrow top btn-blue next fas fa-chevron-right"></i>',
                //'speed': 5000,
                'touchThreshold': 100,
                'infinite': false,
                'responsive' : [
                    {
                        'breakpoint' : 1100,
                        'settings' : {
                            'slidesToShow' : 3,
                        }
                    },
                    {
                        'breakpoint' : 800,
                        'settings' : {
                            'slidesToShow' : 2,
                        }
                    },
                    {
                        'breakpoint' : 695,
                        'settings' : {
                            'slidesToShow' : 1,
                        }
                    }
                ]
            }
        },
        carouselChanged : function(event, slick, currentSlide) {
            this.selectedStepIndex = currentSlide;
        }
    }
}
</script>